import { render } from "./AreasPage.vue?vue&type=template&id=437b49ed&scoped=true"
import script from "./AreasPage.vue?vue&type=script&lang=js"
export * from "./AreasPage.vue?vue&type=script&lang=js"

import "./AreasPage.vue?vue&type=style&index=0&id=437b49ed&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\loop Company\\Apps\\cms-dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-437b49ed"]])

export default __exports__